import { TextInput } from "@mantine/core"
import { random } from "lodash"
import type { TQuestionProps } from "./types"

export function QuestionNumber({ question, value, setValue, preview, autoFocus, field }: TQuestionProps) {
  if (preview && !value) value = random(0, 100)

  const { onBlur, onFocus, error } = field || {}

  return (
    <TextInput
      size="md"
      type="number"
      value={value ?? ""}
      error={error}
      onBlur={onBlur}
      onFocus={onFocus}
      disabled={preview}
      autoFocus={autoFocus}
      required={question.is_required}
      onChange={(e) => {
        const value = e.currentTarget.value
        setValue(value === "" ? null : parseInt(value, 10))
      }}
    />
  )
}
